<template>
  <div class="top">
    <div class="logo">
      <img :src="require('@/assets/img/logo.png')" alt="" @click="myIndex">
      <div class="search" @click="gotoSearch" v-show="$route.name !== 'Search'"><span>搜索</span></div>
    </div>
    <div class="search-nav">
      <div class="search-nav-container">
        <ul>
          <li ref="allClassify" class="all-classify" @mouseenter="showDetail()" @mouseleave="hideDetail()">
            <Icon type="md-list" />
            <span>所有产品分类</span>
          </li>
          <li><router-link :class="{'active': !selectId}" to="/">首页</router-link></li>
          <li :class="{'active': item.id == selectId}" v-for="item in classifyList" :key="item.id"><router-link :to="'/list/'+item.id">{{item.name}}</router-link></li>
        </ul>
      </div>
    </div>
    <div class="nav-side-detail" ref="allClassifyPanel" v-show="panelActiveIndex == 1" @mouseenter="showDetail()" @mouseleave="hideDetail()">
      <GoodsListNavSide></GoodsListNavSide>
    </div>
    <!-- <Spin size="large" fix v-if="isLoading"></Spin> -->
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import GoodsListNavSide from '@/components/nav/GoodsListNavSide'

export default {
  props: ['classifyId'],
  name: 'GoodsListNav',
  data () {
    return {
      panelActiveIndex: 0
    }
  },
  created() {
    this.loadCurrentClassifyId(this.classifyId)
    this.loadClassifyList().then(res => {
      this.checkClassify(res)
    })
  },
  mounted() {
    window.onscroll = function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.$refs.allClassifyPanel.style.top = this.$refs.allClassify.offsetTop + this.$refs.allClassify.offsetHeight - scrollTop + 'px';
    }
  },
  computed: {
    ...mapGetters(['breadCrumbList']),
    ...mapState(['classifyList', 'currentClassifyId', 'isLoading']),
    selectId() {
      return this.breadCrumbList[0] && this.breadCrumbList[0].id
    }
  },
  watch: {
    "$route"() {
      // this.loadCurrentClassifyId(this.classifyId)
      this.panelActiveIndex = 0
    },
    "classifyId"() {
      this.loadCurrentClassifyId(this.classifyId)
      this.checkClassify()
    }
  },
  methods: {
    ...mapActions(['loadClassifyList', 'loadCurrentClassifyId']),
    // 校验是否是一级
    checkClassify(classifyList) {
      var list = classifyList ||  this.classifyList
      var tmp = list.filter(item => { return item.id == this.classifyId })
      if (tmp && tmp[0]) {
        var classifyId = tmp[0].children[0].id
        this.$router.replace('/list/' + classifyId)
      }
    },
    showDetail () {
      this.panelActiveIndex = 1
    },
    hideDetail () {
      this.panelActiveIndex = 0
    },
    myIndex() {
      this.$router.push('/')
    },
    gotoSearch() {
      this.$router.push('/search')
    }
  },
  mounted () {
    try {
      this.$refs.allClassifyPanel.style.left = this.$refs.allClassify.offsetLeft + 'px';
      this.$refs.allClassifyPanel.style.top = this.$refs.allClassify.offsetTop + this.$refs.allClassify.offsetHeight + 'px';
    } catch (error) {
    }
  },
  updated () {
    try {
      this.$refs.allClassifyPanel.style.left = this.$refs.allClassify.offsetLeft + 'px';
      this.$refs.allClassifyPanel.style.top = this.$refs.allClassify.offsetTop + this.$refs.allClassify.offsetHeight + 'px';
    } catch (error) {
    }
  },
  components: {
    GoodsListNavSide,
  }
};
</script>

<style lang="less" scoped>
.top {
  background-color: #fff;
}
.logo {
  width: @page-main-width;
  margin: 0px auto;
  display: flex;
  align-items: center;

  .search {
    height: 40px;
    width: 40%;
    border: 2px solid @theme-code;
    margin-top: 10px;
    margin-left: 20%;
    padding-left: 15px;
    position: relative;
    box-sizing: border-box;
    cursor: pointer;

    span {
      height: 40px;
      border: 2px solid @theme-code;
      width: 100px;
      text-align: center;
      position: absolute;
      right: -2px;
      top: -2px;
      background: @theme-code;
      color: #FFF;
      box-sizing: border-box;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      letter-spacing: 3px;
    }
  }
}
.logo img{
  width: 180px;
  height: 65px;
  margin: 40px 0 30px;
  cursor: pointer;
}
.search-nav{
  width: 100%;
  height: 48px;
  border-bottom: 2px solid @theme-code;
}
.search-nav-container{
  width: @page-main-width;
  height: 48px;
  margin: 0px auto;
  overflow: hidden;
}
.search-nav-container ul{
  margin: 0px;
  padding-left: 0px;
  list-style: none;
}
.search-nav-container li{
  cursor: pointer;
  margin-left: 25px;
  line-height: 48px;
  color: @theme-code;
  font-size: 14px;
  font-weight: bold;
  float: left;

  &:first-child{
    width: @left-side-width;
    text-align: left;
    background:@theme-code;
    margin: 0px;
    color: #fff;
    .ivu-icon {
      color: #FFF;
      margin: 0 10px 0 20px;
      font-size: 20px;
    }
  }
  a{
    color: #000000;
    text-decoration: none;
    display: inline-block;
    line-height: 48px;
  }
  &.active a, 
  &:hover a, 
  a.active{
    color: @theme-code;
  }
}

.nav-side-detail {
  position: absolute;
  width: @left-side-width;
  min-height: 560px;
  padding: 0px;
  background-color: #FFFFFF;
  z-index: 10000;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/GoodsListNav.vue